var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../utils/mobx/decorators/memoize';
import { DirectivePoseQuestion } from './modules/DirectivePoseQuestion';
import { DirectiveCompleteQuestion } from './modules/DirectiveCompleteQuestion';
import { DirectiveStartNewCycle } from './modules/DirectiveStartNewCycle';
import { DirectiveFinishQuestion } from './modules/DirectiveFinishQuestion';
export class Directive {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get directivePoseQuestion() {
        return new DirectivePoseQuestion(this);
    }
    get directiveCompleteQuestion() {
        return new DirectiveCompleteQuestion(this);
    }
    get directiveFinishQuestion() {
        return new DirectiveFinishQuestion(this);
    }
    get directiveStartNewCycle() {
        return new DirectiveStartNewCycle(this);
    }
}
__decorate([
    memoize
], Directive.prototype, "directivePoseQuestion", null);
__decorate([
    memoize
], Directive.prototype, "directiveCompleteQuestion", null);
__decorate([
    memoize
], Directive.prototype, "directiveFinishQuestion", null);
__decorate([
    memoize
], Directive.prototype, "directiveStartNewCycle", null);
